import {
    MenuItem,
    ListItemIcon,
    ListItemText,
    Modal,
    Paper,
    Typography,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Stack,
    Button,
} from '@b2b-ui';
import { availableLocales, getCurrentLocale, setLocaleCookie } from '@b2b-ui/utilities/locales';
import Translate from '@mui/icons-material/Translate';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

const modalStyle = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 663,
    boxShadow: 24,
    p: 4,
};

type LanguageModalProps = {
    onModalClose?: () => void;
};

export const LanguageModal = ({ onModalClose }: LanguageModalProps) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        onModalClose?.();
        return setOpen(false);
    };
    const [locale, setLocal] = useState(getCurrentLocale());
    const { formatMessage } = useIntl();
    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <MenuItem
                disableRipple
                onClick={() => {
                    handleOpen();
                }}
            >
                <ListItemIcon>
                    <Translate />
                </ListItemIcon>
                <ListItemText>{formatMessage({ id: 'languages.title' })}</ListItemText>
            </MenuItem>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper sx={modalStyle}>
                    <Typography variant="h3">{formatMessage({ id: 'languages.title' })}</Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                        {formatMessage({ id: 'languages.explanation' })}
                    </Typography>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            setLocaleCookie(locale);
                            window.location.reload();
                        }}
                    >
                        <FormGroup>
                            {availableLocales.map((availableLocale) => (
                                <FormControlLabel
                                    key={availableLocale}
                                    control={
                                        <Checkbox
                                            onChange={() => setLocal(availableLocale)}
                                            checked={availableLocale === locale}
                                        />
                                    }
                                    label={formatMessage({
                                        id: `languages.${availableLocale}`,
                                    })}
                                />
                            ))}
                        </FormGroup>
                        <Stack direction="row" justifyContent="flex-end" mt={2} gap={2}>
                            <Button onClick={handleClose} variant="outlined">
                                {formatMessage({ id: 'form.cancel' })}
                            </Button>
                            <Button type="submit">{formatMessage({ id: 'form.submit' })}</Button>
                        </Stack>
                    </form>
                </Paper>
            </Modal>
        </div>
    );
};
